import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import WrapAuthRoute from '../routes/WrapAuthRoutes'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import TopBarLogo from '../header/topBarLogo'
import PaymentMethodForm from './paymentMethodForm'
import { redirectToAuthWithFrom } from '../utils/UserContext'
import { SnackbarProvider } from 'notistack'
import { isEmpty } from 'lodash'
import { CircularProgress } from '@material-ui/core'

const ChangePaymentMethod = (props) => {
  const { t, i18n } = useTranslation()
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_TOKEN)
  const [booking, setBooking] = useState(null)
  const [property, setProperty] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const { bookingId } = useParams()

  useEffect(() => {
    const getData = async () => {
      try {
        const { data } = await axios.get(`${process.env.REACT_APP_BOOKING_API}/${bookingId}`)
        setBooking(data)
        setIsLoading(false)
      } catch (e) {
        if (e.response.status === 401) {
          redirectToAuthWithFrom()
        }
        setIsLoading(false)
      }
    }
    getData()
  }, [])

  if (isLoading && isEmpty(booking) && isEmpty(property)) {
    return (
      <div className="flex flex-col h-full lg:items-evenly items-center py-12">
        <CircularProgress />
        <div className="justify-evenly">Getting data...</div>
      </div>
    )
  }

  return (
    <WrapAuthRoute>
      <SnackbarProvider maxSnack={3}>
        <Elements stripe={stripePromise}>
          <div className="fixed w-full top-0 left-0 shadow-md z-50">
            <TopBarLogo />
          </div>
          <div className="flex flex-col h-full lg:items-evenly">
            <div className="px-2 w-full flex flex-col pt-4 lg:pt-16 items-start justify-start overflow-auto">
              <div className="w-full flex flex-row items-start justify-evenly">
                <div className="w-full sm:w-full lg:w-6/12 xl:w-5/12 px-2">
                  <PaymentMethodForm booking={booking} />
                </div>
              </div>
            </div>
          </div>
        </Elements>
      </SnackbarProvider>
    </WrapAuthRoute>
  )
}
export default withRouter(ChangePaymentMethod)
